import React, { useState, useEffect } from "react";
import httpClient from "../../services/httpClient";
import "../../styleSheet/main/components/TODO/historyForTODO/historyForTODO.css";

const HistoryManagerTODO = ({ userId }) => {
  const [completedTasks, setCompletedTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTaskHistory = async () => {
      try {
        const response = await httpClient.get(
          `/ToDoTasks/assigned-to-me/by-user/${userId}/history`,
          { withAuth: true }
        );

        // API returns: id, title, completedAt
        const historyTasks = response.data || [];

        // Transform history tasks to match current structure
        const transformedHistoryTasks = historyTasks.map((task) => ({
          text: task.title,
          date: task.completedAt,
          comment: "",
          id: task.id,
          completedDate: task.completedAt,
        }));

        setCompletedTasks(transformedHistoryTasks);
      } catch (err) {
        setError("Nie udało się pobrać historii zadań.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchTaskHistory();
  }, [userId]);

  if (isLoading) {
    return <p>Ładowanie historii zadań...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div className="history-overlay">
      <div className="history-content">
        <p>Historia zadań TODO</p>
        <div className="completed-tasks">
          {completedTasks.length === 0 ? (
            <div className="lack">Brak zadań w historii.</div>
          ) : (
            completedTasks.map((task, index) => (
              <div key={index} className="completed-task">
                <span>
                  <strong>Zadanie :</strong> {task.text}
                </span>
                <span>
                  <strong>Ukończone :</strong>{" "}
                  {new Date(task.date).toLocaleDateString("pl-PL")}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoryManagerTODO;
